import BaseComponent from "../../../../lib/components/BaseComponent";
import PropTypes from "prop-types";
import React from "react";
import  MuiButtonGroup from '@mui/material/ButtonGroup';

class ButtonGroup extends BaseComponent {

  render() {

    let variant = this.props.variant || 'contained';
    let size = this.props.size || 'medium';

    return <MuiButtonGroup variant={variant} size={size} sx={{boxShadow: 0}}>
      {this.props.children}
    </MuiButtonGroup>
  }
}

ButtonGroup.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['outlined', 'contained']),
  color: PropTypes.oneOf(['primary', 'secondary', 'light', 'dark']),
  delimiterColor: PropTypes.oneOf(['white', 'primary'])
}

export default ButtonGroup;
